//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'RequestYandexExecutorField',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    employee: function () {
      return this.value || null
    }
  },
  methods: {
    formatEmployee: function (value) {
      const assignedEmployeeName = value.assignedEmployee && value.assignedEmployee.name
      const replacementAssignedEmployeeName = assignedEmployeeName && assignedEmployeeName !== value.fio ? assignedEmployeeName : null
      return value.login + (value.fio ? ' (' + value.fio + (replacementAssignedEmployeeName ? (' -> ' + replacementAssignedEmployeeName) : '') + ')' : '')
    }
  }
}

